import axiosInstance from '../../../util/axiosInstance';
import { getToken } from '../../../util/Cookies';

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Image Upload
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const uploadImage = async (file) => {
  const token = getToken();
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await axiosInstance.post("/gallery/upload", formData, {
      headers: {
        Authorization: `${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    
    if (response.status === 200 || response.status === 201) {
      return response.data.file.id;
    }
    throw new Error(response.data.message || "Unable to upload image");
  } catch (error) {
    console.error("Error uploading image:", error);
    throw error;
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Venue Types
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const fetchVenueTypes = async () => {
  try {
    const response = await axiosInstance.get("/venues/types");
    if (response.status === 200) {
      return Array.isArray(response.data.data) ? response.data.data : [];
    }
    return [];
  } catch (error) {
    console.error("Error in fetchVenueTypes:", error);
    return [];
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Venue Type Categories
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const fetchVenueTypeCategories = async (typeId) => {
  try {
    const response = await axiosInstance.get("/venues/categories", {
      params: { typeId }
    });
    if (response.status === 200) {
      return Array.isArray(response.data.data) ? response.data.data : [];
    }
    return [];
  } catch (error) {
    console.error("Error in fetchVenueTypeCategories:", error);
    return [];
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Sub Categories
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const fetchSubCategories = async (categoryId) => {
  try {
    const response = await axiosInstance.get("/venues/subcategories", {
      params: { categoryId }
    });
    if (response.status === 200) {
      return Array.isArray(response.data.data) ? response.data.data : [];
    }
    return [];
  } catch (error) {
    console.error("Error in fetchSubCategories:", error);
    return [];
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Rules
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const fetchRules = async () => {
  try {
    const response = await axiosInstance.get("/v1/rules");
    if (response.status === 200) {
      return Array.isArray(response.data.data) ? response.data.data : [];
    }
    return [];
  } catch (error) {
    console.error("Error in fetchRules:", error);
    return [];
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Venues
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const fetchVenues = async () => {
  try {
    const response = await axiosInstance.get("/v1/venues");
    if (response.status === 200) {
      return Array.isArray(response.data.data) ? response.data.data : [];
    }
    return [];
  } catch (error) {
    console.error("Error in fetchVenues:", error);
    return [];
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Fetch Single Venue
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const fetchVenueById = async (venueId) => {
  try {
    const response = await axiosInstance.get(`/venues/${venueId}`);
    if (response.status === 200) {
      return response.data.data;
    }
    return null;
  } catch (error) {
    console.error("Error in fetchVenueById:", error);
    return null;
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Features
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const fetchFeatures = async (typeId, categoryId) => {
  try {
    const response = await axiosInstance.get("/venues/features", {
      params: {
        categoryId: categoryId,
        typeId: typeId
      }
    });
    if (response.status === 200) {
      return Array.isArray(response.data.data) ? response.data.data : [];
    }
    return [];
  } catch (error) {
    console.error("Error in fetchFeatures:", error);
    return [];
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Create Venue
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const createVenue = async (payload) => {
  try {
    const response = await axiosInstance.post("/v1/venues", payload);
    if (response.status === 200 || response.status === 201) {
      console.log("✅ Venue created successfully");
      return response.data;
    }
    throw new Error(response.data.message || "Failed to create venue");
  } catch (error) {
    console.error("❌ Error creating venue:", error);
    throw error;
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Update Venue
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const updateVenue = async (venueId, payload) => {
  try {
    const response = await axiosInstance.put(`/v1/venues/${venueId}`, payload);
    if (response.status === 200 || response.status === 201) {
      console.log("✅ Venue updated successfully");
      return response.data;
    }
    throw new Error(response.data.message || "Failed to update venue");
  } catch (error) {
    console.error("❌ Error updating venue:", error);
    throw error;
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Delete Venue
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const deleteVenue = async (venueId) => {
  try {
    const response = await axiosInstance.delete(`/v1/venues/${venueId}`);
    if (response.status === 200 || response.status === 204) {
      console.log("✅ Venue deleted successfully");
      return true;
    }
    throw new Error(response.data.message || "Failed to delete venue");
  } catch (error) {
    console.error("❌ Error deleting venue:", error);
    throw error;
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Delete Venue Space
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const deleteVenueSpace = async (venueId, spaceId) => {
  try {
    const response = await axiosInstance.delete(`/v1/venues/${venueId}/spaces/${spaceId}`);
    if (response.status === 200 || response.status === 204) {
      console.log("✅ Venue space deleted successfully");
      return true;
    }
    throw new Error(response.data.message || "Failed to delete space");
  } catch (error) {
    console.error("❌ Error deleting venue space:", error);
    throw error;
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Space Calendar
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const fetchSpaceCalendar = async (venueId, spaceId, month) => {
  try {
    const response = await axiosInstance.get(`/v1/calendar?venueId=${venueId}&spaceId=${spaceId}`, {
      params: { month }
    });
    if (response.status === 200) {
      return response.data.data || [];
    }
    return [];
  } catch (error) {
    console.error("Error fetching space calendar:", error);
    return [];
  }
};

export const blockCalendarSlot = async (payload) => {
  try {
    const response = await axiosInstance.post('/v1/calendar/block', payload);
    if (response.status === 200 || response.status === 201) {
      console.log("✅ Calendar slot blocked successfully");
      return true;
    }
    throw new Error(response.data.message || "Failed to block slot");
  } catch (error) {
    console.error("❌ Error blocking calendar slot:", error);
    throw error;
  }
};

export const deleteCalendarEntry = async (entryId) => {
  try {
    const response = await axiosInstance.delete(`/v1/calendar/${entryId}`);
    if (response.status === 200 || response.status === 204) {
      console.log("✅ Calendar entry deleted successfully");
      return true;
    }
    throw new Error(response.data.message || "Failed to delete entry");
  } catch (error) {
    console.error("❌ Error deleting calendar entry:", error);
    throw error;
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Space Categories
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const fetchSpaceCategories = async () => {
  try {
    const response = await axiosInstance.get("/v1/space-categories");
    if (response.status === 200 && response.data.success) {
      return response.data.data || [];
    }
    return [];
  } catch (error) {
    console.error("Error fetching space categories:", error);
    return [];
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Space Types
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const fetchSpaceTypes = async (categoryId) => {
  try {
    const path = categoryId 
      ? `/v1/space-types?categoryId=${categoryId}`
      : '/v1/space-types/all';
    const response = await axiosInstance.get(path);
    if (response.status === 200 && response.data.success) {
      return response.data.data || [];
    }
    return [];
  } catch (error) {
    console.error("Error fetching space types:", error);
    return [];
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Space Features
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const fetchSpaceFeatures = async (typeId) => {
  try {
    const response = await axiosInstance.get(`/v1/space-features?typeId=${typeId}`);
    if (response.status === 200 && response.data.success) {
      return response.data.data || [];
    }
    return [];
  } catch (error) {
    console.error("Error fetching space features:", error);
    return [];
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Space Rules
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const fetchSpaceRules = async (typeId) => {
  try {
    const response = await axiosInstance.get(`/v1/space-rules?typeId=${typeId}`);
    if (response.status === 200 && response.data.success) {
      return response.data.data || [];
    }
  } catch (error) {
    console.warn("Failed to fetch space rules from /v1/space-rules, trying fallback:", error);
  }

  try {
    const response = await axiosInstance.get(`/v1/rules?typeId=${typeId}`);
    if (response.status === 200) {
      return response.data.data || response.data || [];
    }
  } catch (error) {
    console.error("Error fetching space rules fallback:", error);
  }
  return [];
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Cuisine Categories
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const fetchCuisineCategories = async () => {
  try {
    const response = await axiosInstance.get('/cuisine/categories');
    if (response.status === 200) {
      const data = response.data;
      if (Array.isArray(data)) return data;
      if (data.data && Array.isArray(data.data)) return data.data;
    }
    return [];
  } catch (error) {
    console.error("Error fetching cuisine categories:", error);
    return [];
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Menus
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const fetchMenus = async () => {
  try {
    const response = await axiosInstance.get("/v1/menus");
    if (response.status === 200 && response.data.success) {
      return response.data.data || [];
    }
    return [];
  } catch (error) {
    console.error("Error fetching menus:", error);
    return [];
  }
};

export const createMenu = async (payload) => {
  try {
    const response = await axiosInstance.post("/v1/menus", payload);
    if (response.status === 200 || response.status === 201) {
      console.log("✅ Menu created successfully");
      return response.data.data || response.data;
    }
    throw new Error(response.data.message || "Failed to create menu");
  } catch (error) {
    console.error("❌ Error creating menu:", error);
    throw error;
  }
};

export const deleteMenu = async (menuId) => {
  try {
    const response = await axiosInstance.delete(`/v1/menus/${menuId}`);
    if (response.status === 200 || response.status === 204) {
      console.log("✅ Menu deleted successfully");
      return true;
    }
    throw new Error(response.data.message || "Failed to delete menu");
  } catch (error) {
    console.error("❌ Error deleting menu:", error);
    throw error;
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Create Space
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const createSpace = async (venueId, payload) => {
  try {
    const response = await axiosInstance.post(`/v1/venues/${venueId}/spaces`, payload);
    if (response.status === 200 || response.status === 201) {
      console.log("✅ Space created successfully");
      return response.data;
    }
    throw new Error(response.data.message || "Failed to create space");
  } catch (error) {
    console.error("❌ Error creating space:", error);
    throw error;
  }
};

// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// Update Space
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const updateSpace = async (venueId, spaceId, payload) => {
  try {
    const response = await axiosInstance.put(`/v1/venues/${venueId}/spaces/${spaceId}`, payload);
    if (response.status === 200 || response.status === 201) {
      console.log("✅ Space updated successfully");
      return response.data;
    }
    throw new Error(response.data.message || "Failed to update space");
  } catch (error) {
    console.error("❌ Error updating space:", error);
    throw error;
  }
};